import { Observable, catchError, map, of } from 'rxjs'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { CambioDeRegla, InvoiceDueDateRule } from '../../interfaces/invoice-rule.interface'
import { environment } from '@env/environment'

type Wrapped<T> = { error: boolean; msg: string; data: T | null }

/** Las reglas de vencimiento de las facturas. Cuelgan del módulo `invoices`, que es de Contabilidad. */
@Injectable({ providedIn: 'root' })
export class ApiInvoiceRulesService {
  private readonly http = inject(HttpClient)
  private readonly base = `${environment.apiUrl}invoices/due-date-rules`

  findAll(): Observable<InvoiceDueDateRule[]> {
    return this.http.get(this.base).pipe(
      map((r) => (r as Wrapped<InvoiceDueDateRule[]>).data ?? []),
      catchError(() => of([] as InvoiceDueDateRule[])),
    )
  }

  /**
   * Define la regla de una clasificación.
   *
   *! El error NO se traga: el backend rechaza con el motivo escrito para quien lo va a leer —«son
   *! más de 365 días», «solo la RENTA está anclada a una letra»— y silenciarlo dejaría al usuario
   *! con un diálogo que no guarda y no dice por qué.
   */
  update(classification: string, cambio: CambioDeRegla): Observable<Wrapped<{ rule: InvoiceDueDateRule; recalculated: number }>> {
    return this.http.patch(`${this.base}/${classification}`, cambio).pipe(
      map((r) => r as Wrapped<{ rule: InvoiceDueDateRule; recalculated: number }>),
      catchError((e) => of({ error: true, msg: e?.error?.msg || 'No se pudo guardar la regla', data: null })),
    )
  }
}
